import {Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange} from '@angular/core';
import {PermissionsService} from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-sort-v2',
  templateUrl: './sort-v2.component.pug',
  styleUrls: ['./sort-v2.component.scss'],
  standalone: false
})
export class SortV2Component implements OnInit, OnChanges {
  @Input() options: any[] = [];
  @Input() sortBy = '';
  @Output() sortChange = new EventEmitter();
  get sortOrdersNumber(){
    return {
      "Ascending":{
        "label": $localize`Oldest`,
        "value": '',
      },
      "Descending":{
        "label": $localize`Newest`,
        "value": '-',
      },
    }
  }
  sortOrdersWordViewed = {
    "Unread": {
      "label": $localize`Unread`,
      "value": '',
    },
    "Read": {
      "label": $localize`Read`,
      "value": '-',
    },
  }
  sortOrdersOptIn={
    "Newest":{
      "label": $localize`Newest`,
      "value": '-',
    },
    "Oldest":{
      "label": $localize`Oldest`,
      "value": '',
    },
  }
  sortOrdersFrequency = {
    "Most frequent": {
      "label": $localize`Most frequent`,
      "value": '',
    },
    "Least frequent": {
      "label": $localize`Least frequent`,
      "value": '-',
    },
  }
  sortOrdersWord={
    "Ascending":{
      "label": $localize`A-Z`,
      "value": '',
    },
    "Descending":{
      "label": $localize`Z-A`,
      "value": '-',
    },
  }
  sortOrdersFrequencyHighLow = {
    "Highest": {
      "label": $localize`Highest`,
      "value": '-',
    },
    "Lowest": {
      "label": $localize`Lowest`,
      "value": '',
    },
  }
  sortOrdersWordNew = {
    "A-Z": {
      "label": $localize`A-Z`,
      "value": '',
    },
    "Z-A": {
      "label": $localize`Z-A`,
      "value": '-',
    },
  }
  sortOrdersDate = {
    "Most recent": {
      "label": $localize`Most recent`,
      "value": '',
    },
    "Least recent": {
      "label": $localize`Least recent`,
      "value": '-',
    },
  }
  sortOrdersGrouped = {
    "Grouped at top": {
      "label": $localize`Grouped at top`,
      "value": '',
    },
    "Grouped at bottom": {
      "label": $localize`Grouped at bottom`,
      "value": '-',
    },
  }
  selectedOrder = '';
  sortString:any[] = []
  requestTemplate = false;
  constructor(
    private permissionService: PermissionsService
  ) {
    this.requestTemplate = this.permissionService.isFeatureActivated('ent-10605-request-templates');
  }

  ngOnInit(): void {
    if(this.sortBy === "") this.setOrderingParams();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sortBy){
      this.setOrderingParams();
    }
  }
  setOrderingParams(): void{
    if (!this.options || this.options.length === 0) {
      return;
    }
    let selectedOption = {};
    let index = 0;
    let order = false; // False for descending
    if (this.sortBy !== ''){
      index = this.options.findIndex((option)=>
        this.sortBy.replace('-', '') === option['value']
      );
      index = index == -1 ? 0 : index;
      order = !this.sortBy.includes('-');
    }
    selectedOption = this.options[index];
    if (!selectedOption) {
      return
    }
    this.sortBy = selectedOption['label'];
    if (selectedOption['type'] == "word") {
      this.selectedOrder = order ? this.sortOrdersWord["Ascending"]['label'] : this.sortOrdersWord["Descending"]['label'];
    } else if (selectedOption['type'] == "number") {
      this.selectedOrder = order ? this.sortOrdersNumber["Ascending"]['label'] : this.sortOrdersNumber["Descending"]['label'];
    } else if (selectedOption['type'] == "frequency") {
      this.selectedOrder = order ? this.sortOrdersFrequency["Most frequent"]['label'] : this.sortOrdersFrequency["Least frequent"]['label'];
    } else if (selectedOption['type'] == "date") {
      this.selectedOrder = order ? this.sortOrdersDate["Most recent"]['label'] : this.sortOrdersDate["Least recent"]['label'];
    } else if (selectedOption['type'] == "optin") {
      this.selectedOrder = order ? this.sortOrdersOptIn["Oldest"]['label'] : this.sortOrdersOptIn["Newest"]['label'];
    }
  }

  onSelectCol(col, value, dir){
    this.sortBy = col;
    const sortOrdersNew = {
      "Ascending": { "label": $localize`Oldest`, "value": '' },
      "Descending": { "label": $localize`Newest`, "value": '-' }
    };
    this.selectedOrder = sortOrdersNew[dir]['label'];
    let firstElement = sortOrdersNew[dir]['value']+value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(sortOrdersNew[dir]['value']+value);
  }

  onSelectColWord(col, value, dir){
    this.sortBy = col;
    const sortOrders = this.sortOrdersWord;
    this.selectedOrder = sortOrders[dir]['label'];
    const firstElement = sortOrders[dir]['value'] + value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(sortOrders[dir]['value'] + value);
  }

  onSelectColFrequency(col, value, dir){
    this.sortBy = col;
    const sortOrders = this.sortOrdersFrequency;
    this.selectedOrder = sortOrders[dir]['label'];
    let firstElement = sortOrders[dir]+value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(sortOrders[dir]['value']+value);
  }

  onSelectColFrequencyHighLow(col, value, dir){
    this.sortBy = col;
    const sortOrders = this.sortOrdersFrequencyHighLow;
    this.selectedOrder = sortOrders[dir]['label'];
    let firstElement = sortOrders[dir]+value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(sortOrders[dir]['value']+value);
  }

  onSelectColDate(col, value, dir){
    this.sortBy = col;
    const sortOrders = this.sortOrdersDate;
    this.selectedOrder = sortOrders[dir]['label'];
    let firstElement = sortOrders[dir]+value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(sortOrders[dir]['value']+value);
  }

  onSelectColGrouped(col, value, dir){
    this.sortBy = col;
    const sortOrders = this.sortOrdersGrouped;
    this.selectedOrder = sortOrders[dir]['label'];
    let firstElement = sortOrders[dir]+value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(sortOrders[dir]['value']+value);
  }

  onSelectColReadUnread(col, value, dir) {
    const sortOrders  = this.sortOrdersWordViewed;
    this.selectedOrder = sortOrders[dir]['label'];
    const firstElement = sortOrders[dir]['value'] + value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(sortOrders[dir]['value'] + value);
  }
  onSelectColOptIn(col, value, dir) {
    this.sortBy = col;
    this.selectedOrder = this.sortOrdersOptIn[dir]['label'];
    let firstElement = this.sortOrdersOptIn[dir] + value;
    this.sortString.splice(this.sortString.indexOf(firstElement), 1);
    this.sortString = [firstElement].concat(this.sortString);
    this.sortChange.emit(this.sortOrdersOptIn[dir]['value'] + value);
  }

  getColor(label, order){
    if (this.sortBy === label && this.selectedOrder === $localize`${order}`) {
      return '#32735F';
    }
    return '#000';
  }

}
